import { render, staticRenderFns } from "./ExchangeDetail.vue?vue&type=template&id=4b88909a&scoped=true"
import script from "./ExchangeDetail.vue?vue&type=script&lang=js"
export * from "./ExchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ExchangeDetail.vue?vue&type=style&index=0&id=4b88909a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88909a",
  null
  
)

export default component.exports